import React, { useState } from 'react';
import './NewCupon.css';
import baseURL from '../../url';
import Swal from 'sweetalert2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTimes, faTicketAlt, faRandom, faSave } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';

export default function NewCupon({ onCuponCreado }) {
    const [modalOpen, setModalOpen] = useState(false);
    const [codigo, setCodigo] = useState('');
    const [descuento, setDescuento] = useState('');
    const [vigencia, setVigencia] = useState('');
    const [estado, setEstado] = useState('activo');
    const [guardando, setGuardando] = useState(false);

    const generarCodigoAleatorio = () => {
        const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
        let code = '';
        for (let i = 0; i < 6; i++) {
            code += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        setCodigo(code);
    };

    const toggleModal = () => {
        if (!modalOpen) {
            generarCodigoAleatorio();
            setDescuento('');
            setVigencia('');
            setEstado('activo');
        }
        setModalOpen(!modalOpen);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const numDesc = parseFloat(descuento);

        if (!codigo.trim()) {
            toast.warn('Ingresa o genera un código para el cupón');
            return;
        }

        if (isNaN(numDesc) || numDesc <= 0) {
            toast.warn('Ingresa un valor de descuento válido mayor a 0');
            return;
        }

        setGuardando(true);
        try {
            const payload = {
                codigo: codigo.trim().toUpperCase(),
                descuento: numDesc,
                estado: estado,
                vigencia: vigencia || null
            };

            const res = await fetch(`${baseURL}/cuponPost.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            const data = await res.json();
            setGuardando(false);

            if (data.mensaje) {
                Swal.fire({
                    title: '¡Cupón creado!',
                    text: `El cupón "${codigo.toUpperCase()}" ha sido registrado correctamente.`,
                    icon: 'success',
                    timer: 2000,
                    showConfirmButton: false
                });
                toggleModal();
                if (onCuponCreado) onCuponCreado();
            } else {
                toast.error(data.error || 'No se pudo crear el cupón');
            }
        } catch (err) {
            setGuardando(false);
            console.error(err);
            toast.error('Error de red al crear el cupón');
        }
    };

    return (
        <div className="newCuponWrapper">
            <button type="button" className="btnNuevoCupon" onClick={toggleModal}>
                <FontAwesomeIcon icon={faPlus} /> Crear Cupón
            </button>

            {modalOpen && (
                <div className="modalCuponOverlay">
                    <div className="modalCuponContent">
                        <div className="modalCuponTop">
                            <h3><FontAwesomeIcon icon={faTicketAlt} /> Nuevo Cupón de Descuento</h3>
                            <button className="btnCloseModalCupon" onClick={toggleModal}>
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>

                        <form onSubmit={handleSubmit} className="formCupon">
                            <div className="formField">
                                <label>Código Promocional:</label>
                                <div className="inputWithGenerator">
                                    <input
                                        type="text"
                                        placeholder="Ej: PROMO10"
                                        value={codigo}
                                        onChange={(e) => setCodigo(e.target.value.toUpperCase())}
                                        required
                                        style={{ textTransform: 'uppercase', letterSpacing: '1px', fontWeight: '700' }}
                                    />
                                    <button
                                        type="button"
                                        className="btnGenerarRandom"
                                        onClick={generarCodigoAleatorio}
                                        title="Generar código al azar"
                                    >
                                        <FontAwesomeIcon icon={faRandom} /> Generar
                                    </button>
                                </div>
                            </div>

                            <div className="formRowGrid">
                                <div className="formField">
                                    <label>Descuento ($):</label>
                                    <input
                                        type="number"
                                        step="0.01"
                                        placeholder="0.00"
                                        value={descuento}
                                        onChange={(e) => setDescuento(e.target.value)}
                                        required
                                    />
                                </div>

                                <div className="formField">
                                    <label>Estado:</label>
                                    <select
                                        value={estado}
                                        onChange={(e) => setEstado(e.target.value)}
                                    >
                                        <option value="activo">Activo</option>
                                        <option value="inactivo">Inactivo</option>
                                    </select>
                                </div>
                            </div>

                            <div className="formField">
                                <label>Vigencia / Fecha de vencimiento (opcional):</label>
                                <input
                                    type="date"
                                    value={vigencia}
                                    onChange={(e) => setVigencia(e.target.value)}
                                />
                            </div>

                            <div className="modalCuponActions">
                                <button type="button" className="btnCancelarCupon" onClick={toggleModal} disabled={guardando}>
                                    Cancelar
                                </button>
                                <button type="submit" className="btnGuardarCupon" disabled={guardando}>
                                    <FontAwesomeIcon icon={faSave} /> {guardando ? 'Guardando...' : 'Crear Cupón'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}
